export default "__VITE_ASSET__BMI0KMD___"